import { render } from "./SCProjekt.vue?vue&type=template&id=58152194"
import script from "./SCProjekt.vue?vue&type=script&lang=js"
export * from "./SCProjekt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__